import { create } from 'zustand'
import { contractApi } from '../services'
import i18n from '../i18n'

const useContractStore = create((set, get) => ({
  // Состояние
  availableItems: [], // Список доступных скинов для контракта
  selectedItems: [], // Выбранные предметы (от 3 до 10)
  contractResult: null, // Результат контракта { donors, donorsCost, win }
  isLoading: false,

  // Установка доступных предметов (вызывается из api.js)
  setAvailableItems: (items) => {
    console.log('📦 Установка доступных предметов для контракта в store:', items?.length || 0)
    set({ availableItems: items || [] })
  },

  // Загрузка доступных предметов для контракта
  loadAvailableItems: async () => {
    set({ isLoading: true })
    try {
      const items = await contractApi.getAvailableItems()
      
      // Устанавливаем данные напрямую в store
      set({ availableItems: items || [] })
      
      return items
    } catch (error) {
      console.error('❌ Ошибка загрузки предметов для контракта:', error)
      set({ availableItems: [] })
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

  // Переключение выбора предмета
  toggleItemSelection: (item) => {
    const { selectedItems } = get()
    const isSelected = selectedItems.some(i => i.id === item.id)
    
    if (isSelected) {
      // Убираем предмет из выбранных
      set({ selectedItems: selectedItems.filter(i => i.id !== item.id) })
    } else {
      // Добавляем предмет, если не достигнут максимум (10)
      if (selectedItems.length < 10) {
        set({ selectedItems: [...selectedItems, item] })
      }
    }
  },

  // Очистка выбранных предметов
  clearSelection: () => {
    set({ selectedItems: [] })
  },

  // Получение суммарной стоимости выбранных предметов
  getTotalCost: () => {
    const { selectedItems } = get()
    return selectedItems.reduce((sum, item) => sum + (item.price || 0), 0)
  },

  // Проверка, можно ли запустить контракт (от 3 до 10 предметов)
  canStartContract: () => {
    const { selectedItems } = get()
    return selectedItems.length >= 3 && selectedItems.length <= 10
  },

  // Получение текста для кнопки контракта
  getButtonText: () => {
    const { selectedItems } = get()
    const count = selectedItems.length
    
    if (count === 0) {
      return i18n.t('contract.selectAtLeast')
    } else if (count === 1) {
      return i18n.t('contract.selectMore', { count: 2 })
    } else if (count === 2) {
      return i18n.t('contract.selectMore', { count: 1 })
    } else {
      return i18n.t('common.continue')
    }
  },

  // Выполнение контракта
  startContract: async () => {
    const { selectedItems } = get()
    
    // Проверка количества предметов
    if (selectedItems.length < 3 || selectedItems.length > 10) {
      throw new Error(i18n.t('contract.errorItemCount'))
    }
    
    set({ isLoading: true })
    try {
      const itemIds = selectedItems.map(item => item.id)
      const result = await contractApi.startContract(itemIds)
      
      // Сохраняем результат контракта
      set({ contractResult: result })
      
      return result
    } catch (error) {
      console.error('❌ Ошибка выполнения контракта:', error)
      throw error
    } finally {
      set({ isLoading: false })
    }
  },

  // Сброс состояния контракта
  resetContract: () => {
    set({
      selectedItems: [],
      contractResult: null,
    })
  },

}))

export default useContractStore
